import ArrowBackIcon from "./../assets/images/arrow-back-icon.svg";
import BellIcon from "./../assets/images/bell-icon.svg";
import BellActiveIcon from "./../assets/images/bell-active-icon.svg";
import Logo from "./../assets/images/Logo.svg";
import Helplineicon from "./../assets/images/helpline-icon.svg";
import Homeicon from "./../assets/images/home-icon.svg";
import Locationicon from "./../assets/images/location-icon.svg";
import Profileicon from "./../assets/images/profile-icon.svg";
import Installericon from "./../assets/images/installer-icon.svg";
import Abouticon from "./../assets/images/about-icon.svg";
import Boxicon from "./../assets/images/box-icon.svg";
import Aboutusicon from "./../assets/images/aboutus-icon.svg";
import Faqicon from "./../assets/images/faq-icon.svg";
import Globeicon from "./../assets/images/globe-icon.svg";
import Facebookicon from "./../assets/images/facebook-icon.svg";
import Logouticon from "./../assets/images/logout-icon.svg";
import Loginicon from "./../assets/images/login-icon.svg";
import Tickicon from "./../assets/images/tick-icon.svg";
import ArrowDownicon from "./../assets/images/arrow-down.svg";

export const images = {
    "background-image": require("./../assets/images/background-image.png"),
    "card-chip": require("./../assets/images/card-chip.png"),
    "orange-location": require("./../assets/images/orange-location.png"),
    "location-1": require("./../assets/images/location-1.png"),
    "location-2": require("./../assets/images/location-2.png"),
    "down-arrow": require("./../assets/images/down-arrows.png"),
    "up-arrow": require("./../assets/images/up-arrows.png"),
    
    /**
     * SVG IMAGES SET
     */
    "arrow-back-icon": ArrowBackIcon,
    "bell-icon": BellIcon,
    "bell-active-icon": BellActiveIcon,
    "Logo": Logo,
    "helpline-icon": Helplineicon,
    "home-icon": Homeicon,
    "location-icon": Locationicon,
    "profile-icon": Profileicon,
    "installer-icon": Installericon,
    "about-icon": Abouticon,
    "box-icon": Boxicon,
    "aboutus-icon": Aboutusicon,
    "faq-icon": Faqicon,
    "globe-icon": Globeicon,
    "facebook-icon": Facebookicon,
    "logout-icon": Logouticon,
    "login-icon": Loginicon,
    "tick-icon": Tickicon,
    "arrow-down": ArrowDownicon,
}
